export default __webpack_public_path__ + "static/aanbouw-mobile-3f32967874d9c46d1bc1f94336914ba9.svg";